// Sentence-end marks (Latin, ellipsis, CJK fullwidth) plus optional closing
// quotes/brackets. Shared by sentences.js and sentenceBuilder.js.
export var SENTENCE_END_RE = /[.!?…。！？]["')\]]*$/;
